import { Routes } from '@angular/router';
import { AdminComponent } from './journey/components/pages/admin/admin.component';
import { HomeComponent } from './journey/components/pages/home/home.component';
import { LcComponent } from './journey/components/pages/admin/lc/lc.component';
import { IamComponent } from './journey/components/pages/admin/iam/iam.component';
import { isAdminGuard } from './journey/guards/is-admin.guard';
import { JourneyComponent } from './journey/components/pages/journey/journey.component';
import { clientSubDomainSelectorGuard } from './journey/guards/client-sub-domain-selector.guard';
import { SectionSelectionComponent } from './journey/components/pages/section-selection/section-selection.component';
import { ReportsComponent } from './journey/components/pages/reports/reports.component';
import { isAdminOrClientAdminGuard } from './journey/guards/is-admin-or-client-admin.guard';
import { ContentAppComponent } from './journey/components/pages/admin/content-app/content-app.component';
import { rememberRouteGuard } from './journey/guards/remember-route-guard.guard';
import { watchForActivityTokenRefreshGuard } from './journey/guards/watch-for-activity-token-refresh.guard';
import { MyComponent } from './journey/components/pages/my/my.component';
import { isLoggedInAndRedirectToDestinationGuard } from './journey/guards/is-logged-in-and-redirect-to-destination.guard';
import { RubricsComponent } from './journey/components/pages/admin/rubrics/rubrics.component';
import { Purchases } from './journey/components/pages/admin/purchases/purchases';
import { SsoLogin } from './journey/components/pages/sso-login/sso-login';
import { redirectToSectionSelectionIfNeeded } from './journey/guards/redirect-to-section-selection-if-needed.guard';
import { isTeacherOrHigherGuard } from './journey/guards/is-teacher-or-higher-guard';
import { SectionEnrollment } from './journey/components/pages/admin/section-enrollment/section-enrollment';
import { Products } from './journey/components/pages/admin/products/products';
import { SetupWizard } from './journey/components/pages/admin/setup-wizard/setup-wizard';
import { SetupWizardState } from '@mira-avant/mtlibs';
import { clientRequiredGuard } from './journey/guards/client-required-guard';
import { setupWizardClientPickerGuard } from './journey/guards/setup-wizard-client-picker-guard';
import { SetupWizardClientPicker } from './journey/components/pages/admin/setup-wizard-client-picker/setup-wizard-client-picker';
import { isDistrictAdminOrHigherGuard } from './journey/guards/is-district-admin-or-higher-guard';
import { Media } from './journey/components/pages/admin/media/media';
import { ProductStatus } from './journey/components/pages/admin/product-status/product-status';
import { StrideAlgorithmReportPage } from './journey/components/pages/admin/stride-algorithm-report/stride-algorithm-report-page';

export const routes: Routes = [
	{
		path: '',
		component: HomeComponent,
	},
	{
		path: 'sso-login',
		component: SsoLogin,
	},
	{
		path: 'home/:state',
		component: HomeComponent,
	},
	{
		path: 'my',
		component: MyComponent,
		canActivate: [rememberRouteGuard, isLoggedInAndRedirectToDestinationGuard, watchForActivityTokenRefreshGuard],
		children: [
			{
				path: 'admin',
				component: AdminComponent,
				canActivate: [isTeacherOrHigherGuard],
			},
			{
				path: 'admin/content-generation',
				loadChildren: () =>
					import('./content-generation/content-generation.routes').then(m => m.CONTENT_GENERATION_ROUTES),
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/lc',
				component: LcComponent,
				canActivate: [isAdminOrClientAdminGuard],
			},
			{
				path: 'admin/iam',
				component: IamComponent,
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/rubrics',
				component: RubricsComponent,
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/purchases',
				component: Purchases,
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/products',
				component: Products,
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/product-status',
				component: ProductStatus,
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/media-depot',
				component: Media,
				canActivate: [isAdminGuard],
			},
			{
				path: 'admin/content-app',
				component: ContentAppComponent,
				canActivate: [isAdminOrClientAdminGuard],
			},
			{
				path: 'admin/setup-wizard',
				canActivate: [isDistrictAdminOrHigherGuard],
				children: [
					// The admin breadcrumb system will allow navigating here in some instances
					// so we redirect to the desired starting point which is the client picker
					{
						path: '',
						redirectTo: SetupWizardState.CLIENT_PICKER,
						pathMatch: 'full',
					},
					{
						path: SetupWizardState.CLIENT_PICKER,
						component: SetupWizardClientPicker,
						canActivate: [setupWizardClientPickerGuard],
					},
					{
						path: ':state/:clientUuid',
						component: SetupWizard,
						canActivate: [clientRequiredGuard],
					},
				],
			},
			{
				path: 'admin/section-enrollment',
				component: SectionEnrollment,
				canActivate: [isTeacherOrHigherGuard],
			},
			{
				path: 'admin/stride-algorithm-report',
				component: StrideAlgorithmReportPage,
				canActivate: [isAdminGuard],
			},
			{
				path: 'sections',
				component: SectionSelectionComponent,
				canActivate: [clientSubDomainSelectorGuard],
			},
			{
				path: 'journey',
				component: JourneyComponent,
				canActivate: [clientSubDomainSelectorGuard, redirectToSectionSelectionIfNeeded],
			},
			{
				path: 'reports',
				component: ReportsComponent,
				canActivate: [clientSubDomainSelectorGuard],
			},
		],
	},
	{
		path: '**',
		redirectTo: '',
		pathMatch: 'full',
	},
];
